module.exports = __webpack_public_path__ + "static/media/goodbye.cdd83ea1.svg";